import { z } from 'zod';
export const GENERATION_INSTRUCTIONS_PATH = '/api/v1/settings/generation';
export const SYSTEM_PROMPT_MAX_LENGTH = 20_000;
export const GenerationInstructionsResourceSchema = z.object({
    systemPrompt: z.string().max(SYSTEM_PROMPT_MAX_LENGTH),
    version: z.number().int().positive().max(2_147_483_647),
    updatedAt: z.string().min(1),
});
export const SaveGenerationInstructionsRequestSchema = z.object({
    systemPrompt: z.string().max(SYSTEM_PROMPT_MAX_LENGTH),
    expectedVersion: z.number().int().positive().max(2_147_483_647),
}).strict();
//# sourceMappingURL=generation-instructions.js.map